import { ICourse } from '@/shared/ICourse';
import { MenuItem } from '@chakra-ui/react';
import { FiX } from 'react-icons/fi';

export const MenuItemDeleteCourse = (props: {
  course: ICourse;
  onDelete: (course: ICourse) => void;
}) => {
  return <MenuItem icon={<FiX />} key='delete' onClick={() => props.onDelete(props.course)}>Delete...</MenuItem>
}
